import api from './api';
import {
  TileData,
  ActivationCode,
  ActivationHistoryEntry,
  CreateActivationHistoryDto,
} from '../types/treasure-hunt';

export interface TreasureHuntMapResponse {
  success: boolean;
  message?: string;
  data?: TileData[][];
  exists?: boolean;
}

export interface ActivationCodeResponse {
  success: boolean;
  message?: string;
  data?: ActivationCode | ActivationCode[];
}

export interface ActivationHistoryResponse {
  success: boolean;
  message?: string;
  data?: ActivationHistoryEntry | ActivationHistoryEntry[];
}

export const treasureHuntApi = {
  // Сохранить карту
  async saveMap(mapData: TileData[][]): Promise<TreasureHuntMapResponse> {
    const response = await api.post('/treasure-hunt/map', {
      mapData: JSON.stringify(mapData),
    });
    return response.data;
  },

  // Получить карту
  async getMap(): Promise<TreasureHuntMapResponse> {
    const response = await api.get('/treasure-hunt/map');
    return response.data;
  },

  // Проверить, существует ли карта
  async checkMapExists(): Promise<TreasureHuntMapResponse> {
    const response = await api.get('/treasure-hunt/map/exists');
    return response.data;
  },

  // Сбросить карту
  async resetMap(): Promise<TreasureHuntMapResponse> {
    const response = await api.delete('/treasure-hunt/map');
    return response.data;
  },

  // Коды активации
  async createActivationCode(code: string): Promise<ActivationCodeResponse> {
    const response = await api.post('/treasure-hunt/activation-codes', { code });
    return response.data;
  },

  async getAllActivationCodes(): Promise<ActivationCodeResponse> {
    const response = await api.get('/treasure-hunt/activation-codes');
    return response.data;
  },

  async getActivationCodeById(id: number): Promise<ActivationCodeResponse> {
    const response = await api.get(`/treasure-hunt/activation-codes/${id}`);
    return response.data;
  },

  async getActivationCodeByCode(code: string): Promise<ActivationCodeResponse> {
    const response = await api.get(`/treasure-hunt/activation-codes/code/${code}`);
    return response.data;
  },

  async validateActivationCode(code: string): Promise<ActivationCodeResponse> {
    const response = await api.post('/treasure-hunt/activation-codes/validate', { code });
    return response.data;
  },

  // Пометить код активации как использованный
  async markCodeAsUsed(code: string): Promise<ActivationCodeResponse> {
    const response = await api.post('/treasure-hunt/activation-codes/mark-used', { code });
    return response.data;
  },

  // Массовая генерация кодов активации
  async generateMultipleCodes(count: number): Promise<ActivationCodeResponse> {
    const response = await api.post('/treasure-hunt/activation-codes/generate-multiple', { count });
    return response.data;
  },

  // Получить все невыгруженные коды активации
  async getUndownloadedActivationCodes(): Promise<ActivationCodeResponse> {
    const response = await api.get('/treasure-hunt/activation-codes/undownloaded');
    return response.data;
  },

  // Пометить коды как выгруженные
  async markCodesAsDownloaded(codeIds: number[]): Promise<ActivationCodeResponse> {
    const response = await api.post('/treasure-hunt/activation-codes/mark-downloaded', { codeIds });
    return response.data;
  },

  // Мигрировать существующие коды (установить isDownloaded = false где NULL)
  async migrateExistingCodes(): Promise<ActivationCodeResponse> {
    const response = await api.post('/treasure-hunt/activation-codes/migrate-existing');
    return response.data;
  },

  // История активаций
  async saveActivationHistory(
    historyData: CreateActivationHistoryDto,
  ): Promise<ActivationHistoryResponse> {
    const response = await api.post('/treasure-hunt/activation-history', historyData);
    return response.data;
  },

  async getAllActivationHistory(): Promise<ActivationHistoryResponse> {
    const response = await api.get('/treasure-hunt/activation-history');
    return response.data;
  },

  async getActivationHistoryByCode(code: string): Promise<ActivationHistoryResponse> {
    const response = await api.get(`/treasure-hunt/activation-history/code/${code}`);
    return response.data;
  },

  async getActivationHistoryById(id: number): Promise<ActivationHistoryResponse> {
    const response = await api.get(`/treasure-hunt/activation-history/${id}`);
    return response.data;
  },
};
